import { Component } from '@angular/core';
import { UserService } from '../services/user.service';
import { Observable } from 'rxjs/Observable';
import { Publisher } from '../model/publisher.class';
import { AuthHttp } from 'angular2-jwt/angular2-jwt';

@Component({
    selector: 'app-publisher-list',
    templateUrl: './publisher.list.component.html'
})
export class PublisherListComponent {

    publishers: Publisher[];
    columns: Array<any> = [
        {
            title: 'Name',
            name: 'name',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Namen filtern' }
        },
        {
            title: 'Ratenmodell',
            name: 'ratemodel',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Ratenmodell filtern' }
        },
        {
            title: 'Kontakt',
            name: 'contact',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Kontakt filtern' }
        }
    ];

    constructor(public userService: UserService) {
        userService.getAll('publisher').subscribe(data => this.publishers = data as Publisher[]);
    }
}



// WEBPACK FOOTER //
// ./src/app/publisherList/publisher.list.component.ts